import { render } from "./MessengerConversation.vue?vue&type=template&id=a2d64748&scoped=true"
import script from "./MessengerConversation.vue?vue&type=script&lang=js"
export * from "./MessengerConversation.vue?vue&type=script&lang=js"

import "./MessengerConversation.vue?vue&type=style&index=0&id=a2d64748&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a2d64748"

export default script